// Paleta compartida por los graficos de este dashboard, para que un mismo
// cliente se identifique con el mismo color en todos los widgets. Se
// necesitan 10 colores (uno por cada cliente del Top 10, tanto en el
// grafico de barras como en la evolucion diaria/mensual).
export const COLORES_CLIENTE = ["#3b82f6", "#22c55e", "#8b5cf6", "#f97316", "#ef4444", "#06b6d4", "#eab308", "#64748b", "#ec4899", "#14b8a6"];
export const COLORES_RANGO_CLIENTE = ["#3b82f6", "#22c55e", "#f97316", "#8b5cf6"];
export const NOMBRES_MES_CORTO = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];
